import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'

const query = graphql`
  query {
    placeholderImage: file(relativePath: { eq: "banner.jpg" }) {
      relativePath
      name
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

const BannerImage = ({ alt }) => {
  const data = useStaticQuery(query)

  return <Img fluid={data.placeholderImage.childImageSharp.fluid} alt={alt} />
}

export default BannerImage
